import { render, staticRenderFns } from "./ProposalTable.vue?vue&type=template&id=3e3b1da2&"
import script from "./ProposalTable.vue?vue&type=script&lang=js&"
export * from "./ProposalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports